<template>
    <div class="login-container">
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" autocomplete="on" label-position="left">

            <div class="title-container">
                <h3 class="title">Login Form</h3>
            </div>

            <el-form-item prop="username">
                <span class="svg-container">
                    <i class="el-icon-user-solid"></i>
                </span>
                <el-input
                ref="username"
                v-model="loginForm.username"
                placeholder="Username"
                name="username"
                type="text"
                tabindex="1"
                autocomplete="on"
                />
            </el-form-item>

            <el-tooltip v-model="capsTooltip" content="Caps lock is On" placement="right" manual>
                <el-form-item prop="password">
                <span class="svg-container">
                    <i class="el-icon-lock"></i>
                </span>
                <el-input
                    :key="passwordType"
                    ref="password"
                    v-model="loginForm.password"
                    :type="passwordType"
                    placeholder="Password"
                    name="password"
                    tabindex="2"
                    autocomplete="on"
                    @keyup.native="checkCapslock"
                    @blur="capsTooltip = false"
                    @keyup.enter.native="handleLogin"
                />
                <span class="show-pwd" @click="showPwd">
                    <!-- <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" /> -->
                    <i class="el-icon-view"></i>
                </span>
                </el-form-item>
            </el-tooltip>
            
            <vue-recaptcha 
                ref="recaptcha"
                @verify="onCaptchaVerified"
                @expired="onCaptchaExpired"
                sitekey="6LfryqkZAAAAAPrsMjr5dNgO4dKso82rvSb56Yob" 
                :loadRecaptchaScript="true"
            >
            </vue-recaptcha>

            <el-button :loading="loading" type="primary" style="width:100%;margin-bottom:30px;" @click.native.prevent="handleLogin">Login</el-button>

        </el-form>
    </div>
</template>

<script>
import {generateHeader} from "@/misc/function.js";
import VueRecaptcha from 'vue-recaptcha';
export default {
    components: { 
        VueRecaptcha 
    },
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please fill the user name'))
            } else {
                callback()
            }
        }
        const validatePassword = (rule, value, callback) => {
            if (value.length < 5) {
                callback(new Error('The password can not be less than 5 digits'))
            } else {
                callback()
            }
        }
        return {
            loginForm: {
                username: '',
                password: '',
                recaptchaToken: ''
            },
            loginRules: {
                username: [{ required: true, trigger: 'blur', validator: validateUsername }],
                password: [{ required: true, trigger: 'blur', validator: validatePassword }]
            },
            passwordType: 'password',
            capsTooltip: false,
            loading: false
        }
    },
    mounted() {
        if (this.loginForm.username === '') {
            this.$refs.username.focus()
        } else if (this.loginForm.password === '') {
            this.$refs.password.focus()
        }
    },
    methods: {
        checkLogin() {
            if(localStorage.getItem("token")){
                this.$axios.post("auth/checkLogin.php" , {
                },
                {
                    headers: generateHeader("loginCheck")
                })
                .then((response) => {
                    if(response.data.code == "200"){
                        this.$router.push('/admin/dashboard')
                    }
                    else{
                        this.$notify.error({
                            title: 'Error',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                    }
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                })
            }
        },
        checkCapslock(e) {
            const { key } = e
            this.capsTooltip = key && key.length === 1 && (key >= 'A' && key <= 'Z')
        },
        showPwd() {
            if (this.passwordType === 'password') {
                this.passwordType = ''
            } else {
                this.passwordType = 'password'
            }
            this.$nextTick(() => {
                this.$refs.password.focus()
            })
        },
        onCaptchaExpired: function () {
            this.$refs.recaptcha.reset();
            this.loginForm.recaptchaToken = ""
        },
        onCaptchaVerified: function (recaptchaToken) {
            const self = this;
            this.loginForm.recaptchaToken = recaptchaToken
        },
        handleLogin() {
            this.loading = true
            // this.loginForm.recaptchaToken = "done"
            if(this.loginForm.recaptchaToken != ""){
                this.$axios.post("auth/login.php", this.loginForm, 
                {
                headers: {
                    Authkey: 'loginAuth'
                }
                })
                .then((response) => {
                    console.log(response.data)
                    if(response.data.code == "200"){
                        localStorage.setItem("token" , response.data.extra.token)
                        localStorage.setItem("expiry" , response.data.extra.logout_time)
                        localStorage.setItem("name" , response.data.body.name)
                        this.$router.push('/admin/dashboard')
                    }
                    else{
                        this.$notify.error({
                            title: 'Error',
                            message: response.data.extra.message
                        });
                    }
                    this.onCaptchaExpired()
                    this.loading = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });

                    this.loading = false
                })
            }
            else{
                this.$notify.error({
                    title: 'Error',
                    message: "Please Verify reCAPTCHA"
                });
            }         
        }
    },
    mounted() {
        this.checkLogin()
    }
}
</script>

<style lang="css" scoped>
.el-button--primary{
    background-color: #ffb606 !important;
    border-color: #ffb606 !important;
}
</style>

<style lang="scss">
$bg:#283443;
$light_gray:#fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: #000;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
$bg:#EFF1F4;
$dark_gray:#889aa4;
$light_gray:#eee;

.login-container {
  min-height: 100vh;
  width: 100%;
  background-color: $bg;
  overflow: hidden;

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding: 160px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: #ffb606;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}
</style>